export default {
  title: '用戶協議',
  docTitle: 'BetCorgi 用戶協議',
  docSubtitle: '使用服務前，請認真閱讀以下內容',
  intro: '請在註冊、登錄及使用平臺服務前仔細閱讀。點擊同意或繼續使用，即表示您理解並接受本協議。',
  s1Title: '協議範圍',
  s1Body:
    '本協議適用於賬號註冊、登錄、充值、提現、遊戲、獎勵、代理及平臺提供的其他相關功能。具體活動規則、頁面提示和風險說明均屬於本協議的組成部分。',
  s2Title: '註冊與賬號安全',
  s2Body:
    '您應提供真實、準確且有效的信息，並妥善保管賬號、登錄密碼、驗證碼及資金密碼。通過您賬號完成的操作，原則上視為本人操作；發現異常時應立即修改密碼並聯繫平臺。',
  s3Title: '用戶資格',
  s3Body:
    '您確認已滿 18 週歲，具備完全民事行為能力，並應自行確認所在地法律允許使用相關服務。平臺有權基於合規、風控或地區限制暫停部分功能。',
  s4Title: '資金與交易',
  s4Body:
    '充值、提現及幣種兌換以提交時頁面顯示的金額、手續費、匯率、限額和到賬說明為準。請僅使用本人合法持有的支付或收款賬戶，並仔細核對收款信息、鏈類型及錢包地址。',
  s5Title: '獎勵與活動',
  s5Body:
    '任務、返水、俸祿、紅包和其他優惠可能設置參與條件、有效期、流水要求及領取限制。異常套利、批量賬號或違反活動規則的行為，平臺可取消資格並追回不當獎勵。',
  s6Title: '禁止行為',
  s6Body:
    '不得冒用他人身份、盜用支付工具、干擾系統、利用漏洞、洗錢、欺詐、非法轉售賬號或實施其他違法違規行為。平臺可視風險採取驗證、限制交易、凍結或終止服務等措施。',
  s7Title: '服務變更與責任',
  s7Body:
    '因維護、網絡、第三方服務或不可抗力可能造成延遲或暫時中斷。平臺將盡力保障服務穩定，並在法律允許的範圍內按照實際情況處理。',
  s8Title: '協議更新與聯繫',
  s8Body:
    '協議更新後將通過頁面提示、站內消息等方式告知。若您不同意更新內容，應停止使用相關服務；如有疑問，可通過在線客服聯繫我們。',
  done: '我已閱讀',
}
